module.exports = __webpack_public_path__ + "img/villa-img- (2).8dd2d9ae.png";